import { gsap } from 'gsap';
import React, { useEffect } from 'react';
import { useOfertaCard } from '../../../context/ofertas-card-context';
import { useOfertasSwipeTracking } from '../../../hooks/use-ofertas-swipe-tracking';
import { CarlineWithOfertas } from '../../../services/ofertas-service/models/ofertas';
import { OfertaGalleryMobile } from './ofertas-gallery-mobile';

export const OfertaCardsContainerMobile = React.forwardRef<
	HTMLDivElement,
	{
		carline: CarlineWithOfertas;
		className: string;
	}
>(({ carline }, ref) => {
	const { containerRef, visibleOfertaIndex } = useOfertasSwipeTracking(carline);
	const { setSelectedOferta } = useOfertaCard();

	// sincronizar selected oferta con la oferta visible en el carrusel
	useEffect(() => {
		setSelectedOferta(carline.ofertas[visibleOfertaIndex] ?? carline.ofertas[0]);
	}, [carline, setSelectedOferta, visibleOfertaIndex]);

	// Animate on activeCarlineIndex change
	useEffect(() => {
		const animateRef = ref && 'current' in ref ? ref.current : containerRef.current;

		if (animateRef) {
			gsap.killTweensOf(animateRef);
			gsap.fromTo(
				animateRef,
				{ opacity: 0, y: -50 },
				{
					opacity: 1,
					y: 0,
					duration: 0.6,
					ease: 'power2.inOut',
					overwrite: 'auto',
				},
			);
		}
	}, [carline, ref]);

	return (
		<div className="ofertas-cards-container-mobile" ref={containerRef}>
			<OfertaGalleryMobile carline={carline} visibleOfertaIndex={visibleOfertaIndex} />
		</div>
	);
});
